<template>
  <div id="company-details">
    <div class="flex md12 xs12">
      <div v-if="!isLoading">

        <div class="vuestic-widget">
          <div class="vuestic-widget-header flex">
            <div class="flex md10">{{company.title}}</div>
            <div @click="$router.push({name: 'companyEdit',params: { companyId: company.id }})" aria-hidden="true" class="icon edit-icon glyphicon flex glyphicon-edit text-right mr-1"></div>
          </div>
          <div class="vuestic-widget-body">
            <vuetable
            :apiMode="apiMode"
            :fields="fields"
            :itemsPerPage="itemsPerPage"
            :defaultPerPage="defaultTablePerPage"
            clickable
            :data="this.documents"
            :queryParams="queryParams"
            :initialPage="initialPage"
            @vuetable:row-dblclicked="openDocumentPreview"
          >
            <div slot="dateSlot" class="date-cell" slot-scope="props">
              <date-cell name="date" v-model="props.rowData.documentDate" :readonly="true" />
            </div>

            <div slot="textSlot" class="text-cell" slot-scope="props">
              <text-cell name="title" :rowData="props.rowData.name" />
            </div>

            <div slot="isPrintedSlot" class="checkbox-cell" slot-scope="props">
              <vuestic-checkbox
                name="print"
                class="xs8"
                :value="!!props.rowData.isPrinted"
                @input="changeDocument(props.rowData,!props.rowData.isPrinted,'isPrinted')"
              />
            </div>

            <div class="checkbox-cell" slot="hasOriginalSlot" slot-scope="props">
              <vuestic-checkbox
                name="original"
                class="xs8"
                :value="!!props.rowData.hasOriginal"
                @input="changeDocument(props.rowData,!props.rowData.hasOriginal,'hasOriginal')"
              />
            </div>

            <div slot="documentReasons" class="text-cell text-center" slot-scope="props">
              {{ reasons.find(r => r.id === props.rowData.invoiceType).description }}
            </div>
            </vuetable>
          </div>
        </div>
      </div>
    </div>
    <div class="flex md12 align--center justify--center">
      <div class="pre-loader-container">
        <vuestic-pre-loader v-show="isLoading" class="pre-loader"></vuestic-pre-loader>

        <div v-if="!isLoading && error != null">{{$t( this.error) }}</div>
      </div>
    </div>
    <company-document-preview
      :noButtons="true"
      :large="true"
      ref="documentPreview"
      :okText="$t('modal.done')"
      :cancelText="$t('modal.cancel')"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DateCell from './DateCell'
import ItemsPerPageDef from '../../../vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition'
import QueryParams from '../../../vuestic-theme/vuestic-components/vuestic-datatable/data/query-params'
import Vuetable from 'vuetable-2'
import CompanyDocumentPreview from '../../documents/CompanyDocumentPreview'

export default {
  components: { Vuetable, DateCell, CompanyDocumentPreview },
  name: 'company-details',
  created () {
    this.$store.commit('app/setLoading', true)
  },
  async mounted () {
    await this.$store.dispatch(
      'companies/selectCompany',
      this.$route.params.companyId
    )
    await this.$store.dispatch(
      'document/getDocuments',
      this.$route.params.companyId
    )
  },
  computed: {
    ...mapState('app', ['isLoading']),
    ...mapState('document', ['documents']),
    ...mapState('companies', {
      company: state => state.selectedCompany
    }),
    fields () {
      return [
        {
          name: '__slot:dateSlot',
          title: this.$t('common.table.date'),
          width: '10%'
        },

        {
          name: 'title',
          dataClass: 'text-left',
          title: this.$t('common.table.documentName'),
          width: '40%'
        },

        {
          name: '__slot:isPrintedSlot',
          title: this.$t('document.isPrinted'),
          titleClass: 'text-center',
          width: '10%'
        },

        {
          name: '__slot:hasOriginalSlot',
          title: this.$t('document.isOriginal'),
          titleClass: 'text-center',
          width: '10%'
        },

        {
          name: '__slot:documentReasons',
          title: this.$t('document.reasons'),
          titleClass: 'text-center',
          width: '10%'
        }
      ]
    },
    reasons () {
      return this.$store.getters['app/reasons'].map(r => {
        return { id: r.id, description: this.$t(r.description) }
      })
    },
  },
  data () {
    return {
      apiMode: false,
      itemsPerPage: ItemsPerPageDef.itemsPerPage,
      defaultTablePerPage: 6,
      initialPage: 1,
      queryParams: QueryParams,
      error: null
    }
  },

  methods: {
    changeDocument (model, value, prop) {
      this.$store.dispatch('document/updateDocument', {
        docId: model.id,
        updates: { [prop]: value }
      })
    },

    openDocumentPreview (rowModel) {
      this.$store.dispatch('document/openDocumentById', rowModel.id)
    }
  }
}
</script>

<style lang="scss">
#company-details {
  .checkbox-cell {
    text-align: right;
  }

  tbody {
    tr {
      &:nth-of-type(even) {
        background-color: #eff4f5;

        &:hover {
          background-color: #f9f9f9;
        }
      }

      &:nth-of-type(odd) {
        background-color: #ffffff;

        &:hover {
          background-color: #f9f9f9;
        }
      }

      &:hover {
        cursor: pointer;
      }

      .form-group {
        margin-bottom: 0;
        margin-top: 0;
        min-height: 0;
      }

      .vuestic-checkbox {
        justify-content: center;
        align-items: center;
        margin-bottom: 0;
      }
    }
  }

  .edit-icon{
    &:hover{
      cursor: pointer;
    }
  }
}
</style>
